import React from 'react';

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import Layout from '../layouts/Layout';
import ProtectedRoute from '../components/ProtectedRoute';
import CallbackPage from '../pages/CallbackPage';
import UserIsDisabledPage from '../pages/UserIsDisabledPage';
import HomePage from '../pages/HomePage';
import AccountPage from '../pages/AccountPage';

//Layouts
import EditBrokerTeamLayout from '../layouts/EditBrokerTeamLayout';

// Broker Setttings
// import BrokerSettingsPage from '../pages/BrokerSettingsPage';
import BrokerPage from '../pages/BrokerSettingsPage/BrokerPage';
import UsersPage from '../pages/BrokerSettingsPage/UsersPage';
import TeamsPage from '../pages/BrokerSettingsPage/TeamsPage';
import AddOrEditTeamPage from '../pages/BrokerSettingsPage/TeamsPage/AddOrEditTeamPage';
import TeamUsersPage from '../pages/BrokerSettingsPage/TeamsPage/TeamUsersPage';

// Loan Files
import LoanFilesPage from '../pages/LoanFilesPage';
import AddOrEditLoanFilePage from '../pages/LoanFilesPage/AddOrEditLoanFilePage';

import { USER_ROLES } from '../constants/main';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <HomePage /> },
          {
            path: 'account',
            element: <AccountPage />,
          },
        ],
      },
      {
        path: 'empty',
        element: <div>Nothing here yet</div>,
      },
      {
        path: 'settings',
        element: <ProtectedRoute roles={[USER_ROLES.owner]} />,
        children: [
          { index: true, element: <Navigate to="/settings/broker" replace /> },
          {
            path: 'broker',
            element: <BrokerPage />,
          },
          {
            path: 'users',
            element: <UsersPage />,
          },
          {
            path: 'teams',
            children: [
              {
                index: true,
                element: <TeamsPage />,
              },
              {
                element: <EditBrokerTeamLayout />,
                children: [
                  { path: 'create', element: <AddOrEditTeamPage /> },
                  {
                    path: ':id',
                    element: <AddOrEditTeamPage />,
                  },
                  {
                    path: ':id/users',
                    element: <TeamUsersPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'loan-files',
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <LoanFilesPage />,
          },
          {
            path: ':id/borrowers',

            children: [
              {
                index: true,
                element: <AddOrEditLoanFilePage section="borrowers" />,
              },
              {
                path: ':borrowerId',
                element: <AddOrEditLoanFilePage section="borrower" />,
              },
            ],
          },
          {
            path: ':id/documents',
            children: [
              {
                index: true,
                element: <AddOrEditLoanFilePage section="documents" />,
              },
              {
                path: ':documentId',
                element: <AddOrEditLoanFilePage section="documents" />,
              },
            ],
          },
          {
            path: ':id/underwriting/*',
            element: <AddOrEditLoanFilePage section="underwriting" />,
          },
          {
            path: ':id/credit/*',
            element: <AddOrEditLoanFilePage section="credit" />,
          },
          {
            path: ':id/details',
            element: <AddOrEditLoanFilePage section="details" />,
          },
        ],
      },
      {
        path: 'callback',
        element: <CallbackPage />,
      },
      // { path: 'about', element: <About /> },
      // { path: 'contact', element: <Contact /> },
    ],
  },
  {
    path: '403',
    index: true,
    element: <UserIsDisabledPage />,
  },

  /*  {
    path: '*',
    element: <NotFound />, // Handles 404 pages
  }, */
]);

export default function Routes() {
  return <RouterProvider router={router} />;
}
